(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './validators', './fields'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./validators'), require('./fields'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.validators, global.fields);
    global.index = mod.exports;
  }
})(this, function (exports, _validators, _fields) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.fields = exports.validators = undefined;

  var validators = _interopRequireWildcard(_validators);

  var fields = _interopRequireWildcard(_fields);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  exports.validators = validators;
  exports.fields = fields;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/form/index.js
// module id = 2044
// module chunks = 1